import { reduce, get, noop, isNil } from 'lodash';
import { MAP_FORM_PROPS_TO_GOOGLE_PROPS } from '../constants';
export const getAddressMapFromPlace = (place, addressParts) => {
    const address = {};
    for (const addressComponent of place.address_components) {
        const addressType = addressComponent.types[0];
        const addressComponentValueKey = addressParts[addressType];
        if (addressComponentValueKey) {
            address[addressType] = addressComponent[addressComponentValueKey];
        }
    }
    const lat = get(place, 'geometry.location.lat', noop)();
    const lon = get(place, 'geometry.location.lng', noop)();
    if (!isNil(lat) && !isNil(lon)) {
        address.coordinates = {
            lat,
            lon,
        };
    }
    return address;
};
export const mapPropsFromSourceWithMap = (source, transformMap) => {
    const groupedValuesWithPriority = reduce(source, (result, value, key) => {
        const targetKey = transformMap[key];
        if (targetKey) {
            let priority = 0;
            if (Array.isArray(MAP_FORM_PROPS_TO_GOOGLE_PROPS[targetKey])) {
                priority = MAP_FORM_PROPS_TO_GOOGLE_PROPS[targetKey].indexOf(key);
            }
            if (!result[targetKey]) {
                result[targetKey] = [{ value, priority }];
            }
            else {
                result[targetKey].push({ value, priority });
            }
        }
        return result;
    }, {});
    const filteredValuesByType = reduce(groupedValuesWithPriority, (result, value, key) => {
        const highestPriorityValue = value.sort((a, b) => a.priority - b.priority)[0].value;
        result[key] = highestPriorityValue;
        return result;
    }, {});
    return filteredValuesByType;
};
//# sourceMappingURL=index.js.map